export default {
  label: {
    description: 'Compared to ',
  },
};
